import axios from 'axios';
import { Context, Effect, Layer } from 'effect';
import { Schema as S } from '@effect/schema';
import * as Url from '../api/url';
export class HttpError {
    source;
    _tag = 'HttpError';
    constructor(source) {
        this.source = source;
    }
}
export const PaginatedBody = S.Struct({
    data: S.Array(S.Unknown),
    next: S.Number,
});
export class HttpService extends Context.Tag('@fixtuur/backpack/HttpService')() {
}
const constructResponse = (body) => ({ _tag: 'HttpResponse', body });
export const get = (url, headers, params) => Effect.tryPromise({
    try: () => axios
        .get(Url.toString(url), { headers, params })
        .then(res => constructResponse(res.data)),
    catch: error => new HttpError(error),
});
export const patch = (url, headers, body) => Effect.tryPromise({
    try: () => axios
        .patch(Url.toString(url), body, { headers })
        .then(res => constructResponse(res.data)),
    catch: error => new HttpError(error),
});
export const post = (url, headers, body) => Effect.tryPromise({
    try: () => axios
        .post(Url.toString(url), body, { headers })
        .then(res => constructResponse(res.data)),
    catch: error => new HttpError(error),
});
export const put = (url, headers, body) => Effect.tryPromise({
    try: () => axios
        .put(Url.toString(url), body, { headers })
        .then(res => constructResponse(res.data)),
    catch: error => new HttpError(error),
});
export const AxiosHttpService = Layer.sync(HttpService, () => ({
    get,
    patch,
    post,
    put,
}));
